import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { SpinnerCircular } from "spinners-react"
import { BattleActionBar } from "@/modals/constructor/battle/BattleScreenModal/ui/BattleActionBar"
import { BattleField } from "@/modals/constructor/battle/BattleScreenModal/ui/BattleField"
import { BattleFighterCard } from "@/modals/constructor/battle/BattleScreenModal/ui/BattleFighterCard"
import { BattleRoundLog } from "@/modals/constructor/battle/BattleScreenModal/ui/BattleRoundLog"
import styles from "./BattleScreenView.module.scss"
import { IBattleScreenViewProps } from "./types"

const BattleScreenViewComponent: FC<IBattleScreenViewProps> = ({
  status,
  retry,
  round,
  autoOn,
  timerText,
  hero,
  mob,
  log,
  field,
  fieldColumns,
  actions,
  onAttack,
  onAttackForm,
  onAbility,
  onPotion,
  onMove,
  onToggleAuto,
  onFlee
}) => {
  const { t } = useTranslation("battle")

  return (
    <div className={styles.BattleScreenView}>
      {status === "loading" && (
        <div className={styles.BattleScreenView_center}>
          <SpinnerCircular
            size={48}
            thickness={120}
            speed={120}
            color="#f0f0f0"
            secondaryColor="#3a3a3a"
          />
        </div>
      )}
      {status === "error" && (
        <div className={styles.BattleScreenView_center}>
          <span>{t("screen.loadError")}</span>
          <div className={styles.BattleScreenView_buttons}>
            <button
              type="button"
              className={styles.BattleScreenView_button}
              onClick={retry}
            >
              {t("screen.retry")}
            </button>
            <button
              type="button"
              className={styles.BattleScreenView_button}
              disabled={!actions.fleeEnabled}
              onClick={onFlee}
            >
              {t("screen.flee")}
            </button>
          </div>
        </div>
      )}
      {status === "ready" && (
        <>
          <header className={styles.BattleScreenView_top}>
            <span className={styles.BattleScreenView_round}>
              {t("screen.round", { round })}
            </span>
            <span className={styles.BattleScreenView_timer}>
              {autoOn ? t("screen.auto") : timerText}
            </span>
          </header>
          <div className={styles.BattleScreenView_fighters}>
            <BattleFighterCard fighter={hero} />
            <BattleFighterCard fighter={mob} />
          </div>
          <BattleField cells={field} columns={fieldColumns} onMove={onMove} />
          <BattleRoundLog lines={log} />
          <BattleActionBar
            actions={actions}
            onAttack={onAttack}
            onAttackForm={onAttackForm}
            onAbility={onAbility}
            onPotion={onPotion}
            onToggleAuto={onToggleAuto}
            onFlee={onFlee}
          />
        </>
      )}
    </div>
  )
}

export const BattleScreenView = memo(BattleScreenViewComponent)
